import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as authActions from '../../actions/authActions';
import * as registrationActions from '../../actions/registrationActions';
import { push } from 'connected-react-router';
import { registrationSelector } from '../../selectors';
import { Container, Grid, Header, Button } from 'semantic-ui-react';
import { ResetPassword } from '../../components/auth';

class ResetPasswordPage extends Component {
	constructor(props) {
		super(props);

		var query = new URLSearchParams(this.props.location.search);
		var code = query.get("code");
		var userId = query.get("userId");

		this.state = {
			code: code,
			userId: userId
		};
		this.onFieldChange = this.onFieldChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onLoginClick = this.onLoginClick.bind(this);
	}
	onLoginClick(e) {
		this.props.actions.push('/');
	}
	onFieldChange(e) {
		const user = { ...this.props.registration.user };
		user[e.target.name] = e.target.value;
		this.props.actions.updateUserRegistration(user);
	}
	onSubmit(e) {
		const { password } = { ...this.props.registration.user };
		const { code, userId } = this.state;
		this.props.actions.resetPassword({ userId, password, code });
	}
	render() {
		const { user } = this.props.registration;
		return (
			<div className='auth login'>
				<Container>
					<Grid columns='equal'>
						<Grid.Column width={7} only='tablet computer' />
						<Grid.Column computer={8} mobile={16} tablet={8}>
							{!user.passwordReset ? (
								<ResetPassword onSubmit={this.onSubmit} onChange={this.onFieldChange} loading={user.loading} error={user.error} data={user} />
							) : (
								<div>
									<Header as='h2' content='Your password has been reset.' />
									<div className='row-center'>
										<Button primary onClick={this.onLoginClick}>
											Login
										</Button>
									</div>
								</div>
							)}
						</Grid.Column>
					</Grid>
				</Container>
			</div>
		);
	}
}

ResetPasswordPage.propTypes = {
	registration: PropTypes.object.isRequired,
	actions: PropTypes.object.isRequired,
	location: PropTypes.object.isRequired
};

const mapStateToProps = (state, ownProps) => {
	return {
		registration: registrationSelector(state)
	};
};

const mapDispatchToProps = (dispatch, ownProps) => {
	return {
		actions: {
			...bindActionCreators(authActions, dispatch),
			...bindActionCreators(registrationActions, dispatch),
			...bindActionCreators({ push }, dispatch)
		}
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ResetPasswordPage);
